module.exports = __webpack_public_path__ + "static/father.a920ab77.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/extra/father.png
// module id = 453
// module chunks = 114276838955818